import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { withTranslation } from "react-i18next";
import renderHTML from "react-render-html";
import Typo from "../../components/CustomTypo";
import DrawerCustom from "../../components/DrawerCustom";
import { GiftIcon } from "../../components/icons";
import { dataUtil, usage_type } from "../../wsclient/crmservices/dataUtil";

const heightCover = 264
const heightDesc = 380

const styles = theme => ({
    cover: {
        width: '100%',
        height: heightCover,
        objectFit: 'cover',
        position: 'relative',
    },
    name: {
        width: '100%',
        padding: theme.spacing(2),
        // position: 'absolute',
        // top: heightCover - theme.spacing(12),
        backgroundColor: 'rgba(0,0,0,0.1)',
    },
    description: {
        padding: theme.spacing(4),
        borderRadius: theme.spacing(2),
        margin: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        height: heightDesc
    },
});

function PromotionDetail(props) {
    const { t, classes, promotion } = props;

    const processContentWithURL = (content) => {
        if(content) { 
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return content.replace(urlRegex, function(url) {
                return '<a target="blank" href="' + url + '">' + url + '</a>';
            })
        }
    }

    return (
        <DrawerCustom
            open={props.open}
            onClose={() => props.onClose()}
            fullScreen
            enableBack
            children={
                <Grid item xs={12}>
                    <PromotionItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(promotion.creatives, usage_type.offer_detail)} />
                    <Grid item className={classes.name} >
                        <Typo variant='h3' color='onPrimary'>{promotion.name ? promotion.name : ""}</Typo>
                    </Grid>
                    <Grid item xs={12} className={classes.description}>
                        <Typo variant='subtitle2' >{promotion.short_description ? renderHTML(processContentWithURL(promotion.short_description)) : ""}</Typo>
                        <Typo variant='body1' >{promotion.long_description ? renderHTML(processContentWithURL(promotion.long_description)) : ""}</Typo>
                    </Grid>
                </Grid>
            }
        />
    );
}

function PromotionItemImage(props) {
    const { classes, image } = props;
    if (image) {
        return <img src={image.url} className={classes.cover} />
    } else {
        return (
            <Grid xs={12} item className={classes.cover} alignItems='center' justify='center' container>
                <GiftIcon />
            </Grid>
        )
    }
}

export default withStyles(styles)(withTranslation()(PromotionDetail));